/**
 * IE Tab
 *
 * Exposes a small set of stably-named files, including page-world API shims whose
 * purpose is to let pages talk to the extension.
 * Manifest verified against version 19.3.5.1.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hehijbfgiekmjfkfjpbkbammjbdenadd';
export const ieTab: ExtensionDefinition = {
  id: ID,
  name: 'IE Tab',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000_000,
  signals: [
    { id: 'war-redir-htm', kind: 'web-accessible-resource',
      description: 'Fetch redir.htm — the redirect shim used when opening a page in IE mode.',
      weight: 1, run: () => probeFetch(ID, 'redir.htm') },
    { id: 'war-extapi-wp', kind: 'web-accessible-resource',
      description: 'Fetch js/extapi_wp.js — a page-world API bridge exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'js/extapi_wp.js') },
  ],
};
